import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'David Thompson',
      company: 'TechVenture Labs',
      image: 'https://images.unsplash.com/photo-1758598497635-48cbbb1f6555?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxlbnRyZXByZW5ldXIlMjBzdGFydHVwJTIwc3VjY2VzcyUyMGhhcHB5JTIwb3duZXJ8ZW58MHx8fHwxNzY5NDYyMjI2fDA&ixlib=rb-4.1.0&q=85',
      text: 'Trademark Law Consulting made the entire registration process simple. Their expertise saved us valuable time and gave us full confidence in our brand protection.',
      rating: 5,
    },
    {
      name: 'Emily Rodriguez',
      company: 'Creative Studios Inc.',
      image: 'https://images.unsplash.com/photo-1758598497628-942ad38a6dc4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxlbnRyZXByZW5ldXIlMjBzdGFydHVwJTIwc3VjY2VzcyUyMGhhcHB5JTIwb3duZXJ8ZW58MHx8fHwxNzY5NDYyMjI2fDA&ixlib=rb-4.1.0&q=85',
      text: 'Outstanding service from beginning to end. The team was responsive, professional, and guided us through every stage of the process.',
      rating: 5,
    },
    {
      name: 'Marcus Williams',
      company: 'Bright Horizon Brands',
      image: 'https://images.unsplash.com/photo-1758598497635-48cbbb1f6555?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxlbnRyZXByZW5ldXIlMjBzdGFydHVwJTIwc3VjY2VzcyUyMGhhcHB5JTIwb3duZXJ8ZW58MHx8fHwxNzY5NDYyMjI2fDA&ixlib=rb-4.1.0&q=85',
      text: 'I strongly recommend Trademark Law Consulting. They managed our copyright filing efficiently and explained every step in clear terms.',
      rating: 5,
    },
    {
      name: 'Lisa Anderson',
      company: 'Innovate Solutions',
      image: 'https://images.unsplash.com/photo-1758598497628-942ad38a6dc4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxlbnRyZXByZW5ldXIlMjBzdGFydHVwJTIwc3VjY2VzcyUyMGhhcHB5JTIwb3duZXJ8ZW58MHx8fHwxNzY5NDYyMjI2fDA&ixlib=rb-4.1.0&q=85',
      text: 'Outstanding experience! Trademark Law Consulting provided excellent guidance throughout our trademark registration journey.',
      rating: 5,
    },
    {
      name: 'James Mitchell',
      company: 'NextGen Enterprises',
      image: 'https://images.unsplash.com/photo-1758598497635-48cbbb1f6555?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxlbnRyZXByZW5ldXIlMjBzdGFydHVwJTIwc3VjY2VzcyUyMGhhcHB5JTIwb3duZXJ8ZW58MHx8fHwxNzY5NDYyMjI2fDA&ixlib=rb-4.1.0&q=85',
      text: 'Professional, efficient, and reliable. They made the complex trademark process simple and stress-free for our company.',
      rating: 5,
    },
    {
      name: 'Rachel Turner',
      company: 'Urban Design Co.',
      image: 'https://images.unsplash.com/photo-1758598497628-942ad38a6dc4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxlbnRyZXByZW5ldXIlMjBzdGFydHVwJTIwc3VjY2VzcyUyMGhhcHB5JTIwb3duZXJ8ZW58MHx8fHwxNzY5NDYyMjI2fDA&ixlib=rb-4.1.0&q=85',
      text: 'Highly recommend their services! The dedicated support and clear communication made all the difference.',
      rating: 5,
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentIndex + i) % testimonials.length;
      visible.push({ ...testimonials[index], key: index });
    }
    return visible;
  };

  return (
    <div className="relative" data-testid="testimonial-slider">
      {/* Desktop - 3 testimonials */}
      <div className="hidden md:grid md:grid-cols-3 gap-6">
        {getVisibleTestimonials().map((testimonial, idx) => (
          <motion.div
            key={testimonial.key}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            className="bg-white rounded-3xl p-8 shadow-xl border border-slate-100"
          >
            <div className="flex flex-col items-center text-center">
              <div className="bg-[#E1A334]/10 rounded-full w-20 h-20 flex items-center justify-center text-[#E1A334] font-heading font-bold text-2xl mb-6 border-4 border-[#E1A334]/20">
                {testimonial.name.split(' ').map(n => n[0]).join('')}
              </div>
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-yellow-400 fill-current"
                    viewBox="0 0 20 20"
                  >
                    <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                  </svg>
                ))}
              </div>
              <p className="text-slate-600 text-base leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>
              <h4 className="font-heading font-bold text-slate-900 text-lg">
                {testimonial.name}
              </h4>
              <p className="text-slate-500 text-sm">{testimonial.company}</p>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Mobile - Single testimonial */}
      <div className="md:hidden">
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -100 }}
          transition={{ duration: 0.5 }}
          className="bg-white rounded-3xl p-8 shadow-xl border border-slate-100"
        >
          <div className="flex flex-col items-center text-center">
            <div className="bg-[#E1A334]/10 rounded-full w-20 h-20 flex items-center justify-center text-[#E1A334] font-heading font-bold text-2xl mb-6 border-4 border-[#E1A334]/20">
              {testimonials[currentIndex].name.split(' ').map(n => n[0]).join('')}
            </div>
            <div className="flex gap-1 mb-4">
              {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                <svg
                  key={i}
                  className="w-5 h-5 text-yellow-400 fill-current"
                  viewBox="0 0 20 20"
                >
                  <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                </svg>
              ))}
            </div>
            <p className="text-slate-600 text-lg leading-relaxed mb-6 italic">
              "{testimonials[currentIndex].text}"
            </p>
            <h4 className="font-heading font-bold text-slate-900 text-xl">
              {testimonials[currentIndex].name}
            </h4>
            <p className="text-slate-500">{testimonials[currentIndex].company}</p>
          </div>
        </motion.div>
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-center gap-4 mt-8">
        <Button
          onClick={goToPrevious}
          variant="outline"
          size="icon"
          className="rounded-full h-12 w-12 border-slate-200 hover:bg-[#E1A334]/10 hover:border-[#E1A334]/30"
          data-testid="testimonial-prev-button"
        >
          <ChevronLeft className="h-5 w-5" />
        </Button>
        <Button
          onClick={goToNext}
          variant="outline"
          size="icon"
          className="rounded-full h-12 w-12 border-slate-200 hover:bg-[#E1A334]/10 hover:border-[#E1A334]/30"
          data-testid="testimonial-next-button"
        >
          <ChevronRight className="h-5 w-5" />
        </Button>
      </div>

      {/* Dots */}
      <div className="flex justify-center gap-2 mt-4">
        {testimonials.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`h-2 rounded-full transition-all duration-300 ${
              index === currentIndex ? 'w-8 bg-[#E1A334]' : 'w-2 bg-slate-300'
            }`}
            data-testid={`testimonial-dot-${index}`}
          />
        ))}
      </div>
    </div>
  );
};
